<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="form-group">
            <label for="equipment">Equipment</label>
            <wj-combo-box
                id="equipment"
                name="equipment"
                [(ngModel)]="target.equipment"
                [itemsSource]="equipmentOptions"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                required
            ></wj-combo-box>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="fluidSpecification">Fluid specification</label>
                    <input
                        id="fluidSpecification"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.fluidSpecification"
                        name="fluidSpecification"
                    />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="viscosityGrade">Viscosity / grade</label>
                    <input id="viscosityGrade" type="text" class="form-control" [(ngModel)]="target.viscosityGrade" name="viscosityGrade" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="capacityGallons">Capacity (gal)</label>
                    <input
                        id="capacityGallons"
                        type="number"
                        step="0.01"
                        class="form-control"
                        [(ngModel)]="target.capacityGallons"
                        name="capacityGallons"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="capacityQuarts">Capacity (qt)</label>
                    <input
                        id="capacityQuarts"
                        type="number"
                        step="0.01"
                        class="form-control"
                        [(ngModel)]="target.capacityQuarts"
                        name="capacityQuarts"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="changeIntervalHours">Change interval (hrs)</label>
                    <input
                        id="changeIntervalHours"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.changeIntervalHours"
                        name="changeIntervalHours"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="miles">Miles</label>
                    <input id="miles" type="number" class="form-control" [(ngModel)]="target.miles" name="miles" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea id="notes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
